var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{ref:"container",tag:"component",style:(_vm.style),attrs:{"aria-hidden":!_vm.active,"aria-expanded":_vm.active},on:{"transitionend":_vm.onTransitionEnd}},[(!_vm.hidden)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }